<div class="dns-zone">
  <mat-card appearance="outlined" class="zone-toggle-card">
    @if (zone$ | async; as zone) {
      <div class="header row">
        <h2>DNS Zone</h2>
        <app-status-label [status]="toStatus(zone.status)"></app-status-label>
        <div class="buttons row">
          @if (zone.status === 'DUPLICATE') {
            <button matButton="filled" [disabled]="loadingZone()" (click)="activateZone()">
              <fa-icon [icon]="['fas', 'check']" size="lg"></fa-icon>
              Activate DNS Zone
            </button>
          }
          <button
            matButton="outlined"
            class="app-btn-destructive"
            [disabled]="loadingZone()"
            (click)="deleteZone()"
          >
            <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
            Delete DNS Zone
          </button>
        </div>
      </div>
    } @else {
      <div class="header row">
        <div>
          <h2>DNS Zone</h2>
          <span
            >This website does not have DNS Zone in VMAX yet. To start adding records, create DNS
            Zone first.</span
          >
        </div>
        <div class="buttons">
          <button matButton="filled" [disabled]="loadingZone()" (click)="createZone()">
            <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
            Add DNS Zone
          </button>
        </div>
      </div>
    }
  </mat-card>

  @if (zoneRecords$ | async; as records) {
    @if (zoneEnabled()) {
      <app-search-field
        placeholder="Search Record"
        id="record-search"
        (searchText)="onSearch($event)"
      ></app-search-field>

      <div class="table-container">
        <div class="header row">
          <h2>DNS Records</h2>
          <div class="buttons row">
            <button matButton="filled" (click)="createDNSRecord()" [disabled]="!zoneEnabled()">
              <fa-icon [icon]="['fas', 'plus']" size="lg"></fa-icon>
              Add DNS Record
            </button>
            <button matButton="outlined" [disabled]="!zoneEnabled()">
              <fa-icon [icon]="['fas', 'network-wired']" size="lg"></fa-icon>
              Mail DNS manager
            </button>
            <button
              matButton="outlined"
              (click)="syncDNSZone()"
              [disabled]="!zoneEnabled() || syncingZone()"
            >
              <fa-icon [icon]="['fas', 'arrows-rotate']" size="lg"></fa-icon>
              Sync DNS zone
            </button>
          </div>
        </div>

        <mat-card appearance="outlined" class="zone-records">
          <app-table
            #table
            [columns]="recordsColumns"
            [dataSource]="records"
            [totalCount]="(totalZoneRecords$ | async)?.length || 0"
            (pageChange)="handlePageEvent($event)"
          >
            <ng-container matColumnDef="target">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Target</th>
              <td mat-cell *matCellDef="let element">
                <span
                  [matTooltip]="element.target || element.content.target"
                  [matTooltipShowDelay]="500"
                >
                  {{ element.target || element.content.target }}
                </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
              <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
              <td mat-cell *matCellDef="let element">
                <div class="buttons">
                  <button
                    matRipple
                    class="button"
                    matTooltip="Edit DNS Record"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                  >
                    <fa-icon [icon]="['fas', 'pen']" size="lg"></fa-icon>
                  </button>

                  <button
                    matRipple
                    class="button"
                    matTooltip="Copy DNS Record"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    [cdkCopyToClipboard]="
                      element.content.host + ' ' + element.type + ' ' + element.target
                    "
                    (cdkCopyToClipboardCopied)="onCopied($event)"
                  >
                    <fa-icon [icon]="['fas', 'copy']" size="lg"></fa-icon>
                  </button>
                  <button
                    matRipple
                    class="button"
                    matTooltip="Delete DSN Record"
                    [matTooltipShowDelay]="500"
                    matTooltipPosition="above"
                    (click)="deleteDNSRecord(element.id)"
                  >
                    <fa-icon [icon]="['fas', 'trash']" size="lg"></fa-icon>
                  </button>
                </div>
              </td>
            </ng-container>
          </app-table>
        </mat-card>
      </div>
    }
  }
</div>
